module.exports = __webpack_public_path__ + "img/bg-step-full.1775ce92.svg";